import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.bodyTemperatureFile.loading;
export const selectErrorMessage = (state: RootState) =>
  state.bodyTemperatureFile.error;
export const bodyTemperatureFileResponse = (state: RootState) =>
  state.bodyTemperatureFile.bodyTemperatureFileResponse;
